module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "header-box add-bg"
  }, [_c('div', {
    staticClass: "c-header"
  }, [_vm._m(0), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      class: {
        active: index == _vm.currentPage
      },
      on: {
        "click": function($event) {
          return _vm.goUrl(item.url)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _vm._m(1), _c('div', {
    staticClass: "content"
  }, [_vm._m(2), _vm._m(3), (_vm.jobList.length === 0) ? _c('ul', {
    staticClass: "recruit",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      暂无招聘信息\n    ")]) : _c('ul', {
    staticClass: "recruit"
  }, _vm._l((_vm.jobList), function(item, index) {
    return _c('li', {
      key: index,
      class: _vm.getClass(index),
      on: {
        "click": function($event) {
          return _vm.goDetail(item.positionName)
        }
      }
    }, [_c('h2', [_vm._v(_vm._s(item.positionName) + "\n          "), (item.isUrgent) ? _c('img', {
      attrs: {
        "src": require("./images/icon-urgent.png")
      }
    }) : _vm._e()]), _c('p', [_vm._v(_vm._s(item.positionType) + " | " + _vm._s(item.workPlace))])])
  }), 0), _vm._m(4), _vm._m(5)]), _vm._m(6)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/header-logo-orange-xd.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "banner-content"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("简历投递至: "), _c('span', [_vm._v("jrzp@bajiegroup.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("招聘岗位 "), _c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-jobs"
  }, [_c('a', {
    attrs: {
      "href": "/#/joinUs"
    }
  }, [_vm._v("更多招聘")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("公司福利 "), _c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welfare"
  }, [_c('div', {
    staticClass: "welfare-content"
  }, [_c('div', {
    staticClass: "welfare-item right-margin bottom-margin"
  }, [_c('dl', [_c('dt', [_c('img', {
    attrs: {
      "src": require("./images/icon-marry.png"),
      "alt": ""
    }
  })]), _c('dl', {
    staticClass: "title"
  }, [_vm._v("结婚啦")]), _c('dl', {
    staticClass: "text"
  }, [_vm._v("法定婚假/婚礼礼金")])])]), _c('div', {
    staticClass: "welfare-item right-margin bottom-margin"
  }, [_c('dl', [_c('dt', [_c('img', {
    attrs: {
      "src": require("./images/icon-baby.png"),
      "alt": ""
    }
  })]), _c('dl', {
    staticClass: "title"
  }, [_vm._v("生宝宝了")]), _c('dl', {
    staticClass: "text"
  }, [_vm._v("产检假/产假")]), _c('dl', {
    staticClass: "text"
  }, [_vm._v("陪假/哺乳/生育礼金")])])]), _c('div', {
    staticClass: "welfare-item right-margin bottom-margin"
  }, [_c('dl', [_c('dt', [_c('img', {
    attrs: {
      "src": require("./images/icon-holiday.png"),
      "alt": ""
    }
  })]), _c('dl', {
    staticClass: "title"
  }, [_vm._v("年假")]), _c('dl', {
    staticClass: "text"
  }, [_vm._v("每年可享受5~10天年假")])])]), _c('div', {
    staticClass: "welfare-item bottom-margin"
  }, [_c('dl', [_c('dt', [_c('img', {
    attrs: {
      "src": require("./images/icon-check.png"),
      "alt": ""
    }
  })]), _c('dl', {
    staticClass: "title"
  }, [_vm._v("年度健康体检")]), _c('dl', {
    staticClass: "text"
  }, [_vm._v("每年8~9月定期体检")])])]), _c('div', {
    staticClass: "welfare-item right-margin"
  }, [_c('dl', [_c('dt', [_c('img', {
    attrs: {
      "src": require("./images/icon-birth.png"),
      "alt": ""
    }
  })]), _c('dl', {
    staticClass: "title"
  }, [_vm._v("过生日啦")]), _c('dl', {
    staticClass: "text"
  }, [_vm._v("生日祝福/生日礼品")])])]), _c('div', {
    staticClass: "welfare-item right-margin"
  }, [_c('dl', [_c('dt', [_c('img', {
    attrs: {
      "src": require("./images/icon-welfare.png"),
      "alt": ""
    }
  })]), _c('dl', {
    staticClass: "title"
  }, [_vm._v("五险一金")]), _c('dl', {
    staticClass: "text"
  }, [_vm._v("在工作地缴纳")])])]), _c('div', {
    staticClass: "welfare-item right-margin"
  }, [_c('dl', [_c('dt', [_c('img', {
    attrs: {
      "src": require("./images/icon-sick.png"),
      "alt": ""
    }
  })]), _c('dl', {
    staticClass: "title"
  }, [_vm._v("生病了")]), _c('dl', {
    staticClass: "text"
  }, [_vm._v("病假/医疗期/住院关爱礼金")])])]), _c('div', {
    staticClass: "welfare-item"
  }, [_c('dl', [_c('dt', [_c('img', {
    attrs: {
      "src": require("./images/icon-gone.png"),
      "alt": ""
    }
  })]), _c('dl', {
    staticClass: "title"
  }, [_vm._v("亲属去世")]), _c('dl', {
    staticClass: "text"
  }, [_vm._v("丧假/慰问金")])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b56d49a4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b56d49a4","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/page/index/views/joinUsMain.vue
// module id = 1206
// module chunks = 2